import { ChannelPayloadFilter, ViewStream } from "spyne";
import { gsap } from "gsap";

export class CodeContainerDetailsText extends ViewStream {
  constructor(props = {}) {
    props.tagName = "article";
    props.class = "code-container-details-text";
    // props.data['instxClass'] = props.data.info.instx === undefined ? "instx empty" : "instx"
    //console.log("PROPS DATA DETAILS ",props.data.info.instx,props.data.instxClass,props.data);
    // props.data['paragraphs'] = safeClone(props.data.info.body);
    props.template = require("./templates/code-container-details-text.tmpl.html");
    super(props);
  }

  addActionListeners() {
    // return nexted array(s)

    const { parentVsid, codeBlockId } = this.props;
    const isContainerFilter = new ChannelPayloadFilter({
      payload: (v) => v.vsid === parentVsid,
    });
    const isCodeBlockIdFilter = new ChannelPayloadFilter({
      payload: (v) => v.codeBlockId === codeBlockId,
    });

    return [
      [
        "CHANNEL_CODE_CONTAINER_UPDATE_EVENT",
        "onChannelCodeContainerUpdateEvent",
        isCodeBlockIdFilter,
      ],
      ["CHANNEL_CODE_GEN_ANIM_COMPLETED", "onCodeHasAnimatedOld"],
    ];
  }

  onCodeHasAnimatedOld(){

  }
  onCodeHasAnimated() {
    // gsap.set(this.props.el, {opacity:1})
    //console.log("ANIM TEXT");
    if (this.props !== undefined && this.props.el !== undefined) {
      gsap.to(this.props.el, {
        opacity: 1,
        duration: 0.5,
        ease: "power1.inOut",
      });
    }
  }

  onChannelCodeContainerUpdateEvent() {
    const onCompleteExample = () => this.disposeViewStream();
    // this.props.el$.addClass('before-remove');
    gsap.to(this.props.el, {
      opacity: 0,
      duration: 0.25,
      onComplete: onCompleteExample,
    });
  }

  broadcastEvents() {
    // return nexted array(s)
    return [];
  }

  setInitialState(initialLoad = false) {
    const setOpacity = () => {
      if (this.props === undefined || this.props.el === undefined) {
        return;
      }

      initialLoad === true
        ? gsap.from(this.props.el, { opacity: 0, duration: 0.252 })
        : gsap.set(this.props.el, { opacity: 0 });
    };
    requestAnimationFrame(setOpacity);
  }

  onRendered() {
    //console.log("DETAILS INSTX IS ",this.props.data.info.instx, this.props.data.info.instx===undefined);

    this.props
      .el$(".instx")
      .toggleClass("empty", this.props.data.info.instx === undefined);

    this.setInitialState(this.props.data.initialLoad);

    this.addChannel("CHANNEL_CODE_CONTAINER", true);
    this.addChannel("CHANNEL_CODE_GEN");

    window.setTimeout(this.onCodeHasAnimated.bind(this), 250);
  }
}
